function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MapViewFilterComponent from '../../components/Filters/MapViewFilter';
import { selectMapViewFilter } from '../../store/actions/mapSlice';
var MapViewFilter = function MapViewFilter(props) {
  var dispatch = useDispatch();
  var mapViewFilter = useSelector(function (state) {
    var _state$app, _state$app$project, _state$app$project$co;
    return state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : (_state$app$project = _state$app.project) === null || _state$app$project === void 0 ? void 0 : (_state$app$project$co = _state$app$project.configs) === null || _state$app$project$co === void 0 ? void 0 : _state$app$project$co.mapViewFilter;
  });
  var handleUpdateMapView = function handleUpdateMapView(mapViewFilterName) {
    return dispatch(selectMapViewFilter(mapViewFilterName));
  };

  /**
   * A container component for handling map center and zoom manual updates
   */
  return /*#__PURE__*/React.createElement(MapViewFilterComponent, _extends({
    mapViewFilter: mapViewFilter,
    handleUpdateMapView: handleUpdateMapView
  }, props));
};
export default MapViewFilter;